export class Identidad {
    tipo: string;
    numero: string;
    
    static instance() {
      return new this();
    }
  }